<template>
  <div class="login flex f-center f-end">
    <!-- 登录 -->
    <div v-show="login" class="logins">
      <div v-if="!isWeixin">
        <!-- <div
          class="trans"
          @mousemove="imgshow = false"
          @mouseout="imgshow = true"
          @click="qrcodelogin(1)"
          v-show="!code1"
          alt="saomadegl"
        >
          <div class="imgApp" v-show="imgshow"></div>
        </div>
        <div
          class="trans1"
          @mousemove="imgshow = false"
          @mouseout="imgshow = true"
          @click="qrcodelogin(2)"
          v-show="code1"
        >
          <div class="imgApp" v-show="imgshow"></div>
        </div> -->
      </div>
      <div class="code" v-show="codeshow">
        <div class="topswxl">请使用微信扫码登录！</div>
        <img id="qrcodeDiv" :src="loginurl" />
      </div>
      <div v-show="!codeshow">
        <el-tabs
          v-model="activeName"
          @tab-click="handleClick"
          style="margin-top: 17px"
        >
          <el-tab-pane label="手机登录" name="first">
            <div class="inputs" v-if="tabId == 0">
              <el-input
                placeholder="请输入手机号"
                maxlength="11"
                @input="pnumber"
                prefix-icon="el-icon-phone-outline"
                v-model="phonenumber"
              ></el-input>
              <div class="verify">
                <el-input
                  autocomplete="off"
                  style="margin-top: 0px"
                  placeholder="请输入验证码"
                  prefix-icon="el-icon-key"
                  v-model="phonecode"
                  maxlength="4"
                ></el-input>
                <div
                  @click.stop="sendSmsCode"
                  class="zai-checking"
                  v-if="state === false"
                >
                  获取验证码
                </div>
                <div class="zai-checking zai-time" v-if="state === true">
                  倒计时{{ currentTime }}s
                </div>
              </div>
              <!-- <el-input
              placeholder="请输入密码"
              @input="ppassword"
              show-password
              prefix-icon="el-icon-lock"
              v-model="phonepassword"
            ></el-input> -->
            </div>
            <!-- <div class="forget"><span @click.stop="wj()">忘记密码</span></div> -->
          </el-tab-pane>
          <el-tab-pane label="邮箱登录" name="last">
            <div class="inputs" v-if="tabId == 1">
              <el-input
                placeholder="请输入邮箱"
                prefix-icon="el-icon-message"
                v-model="emailnumber"
              ></el-input>
              <el-input
                placeholder="请输入密码"
                show-password
                prefix-icon="el-icon-lock"
                v-model="emailpassword"
                class="ma-t-20"
              ></el-input>
            </div>
            <!-- <div class="forget"><span @click.stop="wj()">忘记密码</span></div> -->
          </el-tab-pane>
        </el-tabs>
        <div class="guide ma-t-10">
          <el-checkbox @change="guides" v-model="checked"></el-checkbox>
          我同意
          <span @click.stop="fu">《使用条款》</span>
        </div>
        <div @click.stop="logins" class="register">登录</div>
      </div>
      <div @click.stop="register()" class="zhu">注册</div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
  .topswxl {
    color: #fb004d;
    text-align: center;
    margin-top: 60px;
    margin-bottom: 20px;
    font-weight: bold;
  }
  #qrcodeDiv {
    height: 200px;
    width: 200px;
  }
  .trans {
    position: absolute;
    cursor: pointer;
    right: 0;
    width: 64px;
    height: 64px;
    background-image: url('../img/logoqrcode.png');
    background-size: cover;
    background-color: #fff;
    z-index: 10;
  }
  .trans1 {
    position: absolute;
    cursor: pointer;
    right: 0;
    width: 64px;
    height: 64px;
    background-image: url('../img/loginphone.png');
    background-size: cover;
    background-color: #fff;
    z-index: 10;
  }
  .imgApp {
    width: 64px;
    height: 64px;
    background: linear-gradient(225deg, transparent 45px, #fff 0);
  }
  .code {
    width: 200px;
    text-align: center;
    margin: 0px auto;
  }
  
  .login {
    min-width: 1200px;
    position: relative;
    background-image: url('../img/login_bg.png');
    background-size: cover;
    min-height: calc(100% - 100px - 61px);
    .logins {
      width: 358px;
      height: 350px;
      box-sizing: border-box;
      background: #ffffff;
      z-index: 9;
      margin-right: 20%;
      box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.08);
      border-radius: 5px;
      // .find {
      // 	text-align: center;
      // 	font-size: 16px;
      // 	font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      // 	font-weight: bold;
      // 	color: rgba(54, 64, 94, 1);
      // }

      .inputs {
        width: 85%;
        margin: 10px auto 0px auto;
        .el-input__inner {
          border: none;
          border-radius: 0px;
          border-bottom: 1px solid #e6e6e6;
        }
      }
      .forget {
        width: 85%;
        margin: 18px auto 30px auto;
        text-align: right;
        font-size: 12px;
        font-family: MicrosoftYaHei;
        color: rgba(153, 153, 153, 1);
        cursor: pointer;
      }
      .forget span:hover {
        color: red;
        font-weight: 600;
      }
      .guide {
        width: 85%;
        margin: 0px auto 9px auto;
        color: #fb004d;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        span {
          cursor: pointer;
          color: #fb004d;
        }

        .el-radio__label {
          font-size: 12px;
          font-family: MicrosoftYaHei;
          color: rgba(153, 153, 153, 1);
        }
      }
      .register {
        width: 85%;
        height: 44px;
        margin: 20px auto;
        background: #fb004d;
        font-size: 14px;
        font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
        font-weight: bold;
        color: rgba(255, 255, 255, 1);
        line-height: 44px;
        text-align: center;
        cursor: pointer;
      }
      .zhu {
        cursor: pointer;

        width: 60px;
        height: 44px;
        margin: 19px auto 10px auto;
        font-size: 14px;
        font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
        font-weight: bold;
        color: #fb004d;
        line-height: 44px;
        text-align: center;
      }
      .zhu:hover {
        color: red;
        font-weight: 600;
      }
      .verify {
        height: 40px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 20px;
        .el-input__inner {
          width: 60%;
        }
        .zai-checking {
          width: 40%;
          text-align: center;
          font-size: 14px;
          color: #fb004d;
          cursor: pointer;
        }
      }
    }
  }
  @media (max-width: 768px) {
    .login {
      min-width: 100%;
      .logins {
        width: auto;
        left: 5%;
        right: 5%;
      }
    }
  }
  @media (max-width: 375px) {
    .login {
      min-width: 100%;
      .logins {
        width: auto;
        left: 5%;
        right: 5%;
        .el-tabs__item {
          padding: 0 35px;
        }
        .register {
        }
      }
    }
  }
</style>

<style lang="scss">
.login {
  .el-tabs__active-bar {
    background: #fb004d;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #fb004d;
    border-color: #fb004d;
  }

  
  .el-tabs__nav-scroll {
        display: flex;
        margin-left: 50px;
      }
      .el-tabs__item {
        padding: 0 65px;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: rgba(153, 153, 153, 1);
      }
      // el-tabs__item is-top is-active
      .is-active {
        font-size: 14px;
        font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
        font-weight: bold;
        color: #fb004d;
        // background: linear-gradient(90deg, rgba(49, 114, 255, 1) 0%, rgba(24, 144, 255, 1) 100%);
        // -webkit-background-clip: text;
        // -webkit-text-fill-color: transparent;
      }
      .el-tabs__nav-wrap::after {
        background-color: #ffffff;
      }

}

  </style>

<script>
import {
  phonelogin,
  getcodes,
  getWxLoginQrcode,
  getWxScanLogin
} from '../api.js'
export default {
  name: 'Login',
  components: {},
  data() {
    return {
      codeshow: false,
      code1: false,
      imgshow: true,
      fetch_static: false,
      fetch_static2: false,
      activeName: 'first',
      tabId: 0,
      phonenumber: '', //手机登录手机号
      phonepassword: '', //手机登录密码
      checked: true, //勾选条款
      echecked: true,
      emailnumber: '', //邮箱号
      emailpassword: '', //邮箱登录密码
      input2: '',
      radio: 1,
      login: true, //显示登录
      slip: false, //忘记密码显示
      state: false, //是否开启倒计时
      totalTime: 120, //总时间，单位秒
      recordingTime: 0, //记录时间变量
      currentTime: 0, //显示时间变量
      phonecode: '',
      goPage: '/',//登录成功跳转页面，默认首页。如果从上一个页面跳转过来，则改为上一个页面path
      Openid: '',
      isWeixin: false,
      cachecode: '',
      loginurl: ''
    }
  },
  beforeRouteEnter(to, from, next) {
    window.scroll(0, 0)
    console.log(from)
    next((vm) => {
      if (from.path != '/register' && from.path != '/Find') {
        vm.goPage = from.fullPath
      }
    })
  },
  created() {
    let phone = localStorage.getItem('phonenumber')
    let emailh = localStorage.getItem('emailnumber')
    this.phonenumber = phone
    this.emailnumber = emailh
    this.envExamine()
  },
  activated() {
    this.envExamine()
  },
  methods: {
    qrcodelogin(t) {
      var that = this
      if (t == 1) {
        this.codeshow = true
        this.code1 = true
        getWxLoginQrcode().then((res) => {
          if (res.data.Code == 0) {
            that.loginurl = res.data.Data.Url
            that.cachecode = res.data.Data.Key
            setTimeout(() => {
            that.CheckLgon()
          }, 2000)
          } else {
            that.$message.error(res.data.Message)
          }
        })
      } else {
        this.code1 = false
        this.codeshow = false
      }
    },
    CheckLgon() {
      var that=this;
      getWxScanLogin({key:this.cachecode}).then((res) => {
        if (res.data.Code == 0) {
          localStorage.setItem('AccessToken', res.data.Data.AccessToken)
            localStorage.setItem('RefreshToken', res.data.Data.RefreshToken)
            localStorage.setItem(
              'AccessTokenTime',
              res.data.Data.AccessTokenTime
            )
            localStorage.setItem(
              'RefreshTokenTime',
              res.data.Data.RefreshTokenTime
            )
            // localStorage.setItem("phonenumber", phone);
            // localStorage.setItem("password", phonepassword);
            localStorage.setItem('username', res.data.Data.MemberName)
          var returnurl = localStorage.getItem('cacheUrl')
            if (returnurl && returnurl != '') {
              window.location.href = returnurl
            } else {
              setTimeout(() => {
                that.$router.push(that.goPage)
              }, 1000)
            }
        } 
      })
    },
    //环境检查，如果在微信浏览器，没有openid时则获取
    envExamine() {
      var ua = navigator.userAgent.toLowerCase()
      this.isWeixin = ua.indexOf('micromessenger') != -1
      console.log(this.isWeixin)
      if (this.isWeixin) {
        let openid = localStorage.getItem('openid') || ''
        if (openid) {
          this.Openid = openid
        } else {
          //this.$router.replace({ path: '/getOpenid', state: 'Login' })
        }
      }
    },
    // 手机短信验证码
    sendSmsCode() {
      let that = this
      let phone = that.phonenumber
      var reg = 11 && /^((13|14|15|17|18|16|19|11|12)[0-9]{1}\d{8})$/
      if (phone.length < 1) {
        that.$message.error('手机号不能为空哦！')
        return
      } else if (!reg.test(phone)) {
        that.$message.error('手机格式不正确！')
        return
      }
      let phones = { Phone: phone, Source: 'pc', Type: '1' }
      getcodes(phones).then((res) => {
        if (res.data.Code == 0) {
          that.$message({
            message: res.data.Data,
            type: 'success'
          })
          // 把显示时间设为总时间
          that.currentTime = that.totalTime
          //开始倒计时
          that.state = true
          //执行倒计时
          that.checkingTime()
        } else {
          that.$message.error(res.data.Message)
        }
      })
    },
    // 手机号几时
    checkingTime() {
      let that = this
      //判断是否开启
      if (this.state) {
        //判断显示时间是否已到0，判断记录时间是否已到总时间
        if (this.currentTime > 0 && this.recordingTime <= this.totalTime) {
          //记录时间增加 1
          this.recordingTime = this.recordingTime + 1
          //显示时间，用总时间 - 记录时间
          this.currentTime = this.totalTime - this.recordingTime
          //1秒钟后，再次执行本方法
          setTimeout(() => {
            //定时器内，this指向外部，找不到vue的方法，所以，需要用that变量。
            that.checkingTime()
          }, 1000)
        } else {
          //时间已完成，还原相关变量
          this.state = false //关闭倒计时
          this.recordingTime = 0 //记录时间为0
          this.currentTime = this.totalTime //显示时间为总时间
        }
      } else {
        //倒计时未开启，初始化默认变量
        this.state = false
        this.recordingTime = 0
        this.currentTime = this.totalTime
      }
    },
    handleClick(e) {
      // console.log(e);
      this.tabId = e.index
    },
    //忘记密码
    wj() {
      this.$router.push('/Find')
    },

    // 注册
    register() {
      this.$router.replace('/register')
    },
    // 手机号
    pnumber(e) {
      this.phonenumber = e
    },

    //手机登录密码
    ppassword(e) {
      this.phonepassword = e
    },

    guides(e) {
      this.fetch_static = false
      this.checked = e
    },
    eguides(e) {
      this.echecked = e
      this.fetch_static2 = false
    },

    //手机号登录 或邮箱登录
    logins() {
      let that = this
      let data = null
      let loading = null
      if (this.tabId == 0) {
        let phone = that.phonenumber
        let phonepassword = that.phonepassword
        let reg = 11 && /^((13|14|15|17|18|16|19|11|12)[0-9]{1}\d{8})$/
        if (phone.length < 1) {
          that.$message.error('手机号不能为空哦')
          return
        } else if (!reg.test(phone)) {
          that.$message.error('手机格式不正确')
          return
        }
        if (!that.checked) {
          that.$message.error('请勾选服务条款')
          return
        }
        if (that.phonecode == '') {
          that.$message.error('请输入验证码')
          return
        }

        if (/[\u4E00-\u9FA5]/g.test(phonepassword)) {
          that.$message.error('密码不能有汉字')
          return
        }

        loading = this.$loading({
          lock: true,
          text: '提交中',
          spinner: 'el-icon-loading',
          background: '#0000000'
        })
        data = {
          Account: phone,
          Openid: that.Openid,
          Code: that.phonecode,
          Source: 'web',
          Type: '1'
        }
      }
      if (this.tabId == 1) {
        let emailnumber = that.emailnumber
        let phonepassword = that.emailpassword
        let reg =
          /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/

        if (emailnumber.length < 1) {
          that.$message.error('邮箱不能为空哦')
          return
        } else if (!reg.test(emailnumber)) {
          that.$message.error('邮箱格式不正确')
          return
        }
        if (!that.checked) {
          that.$message.error('请勾选服务条款')
          return
        }

        if (!phonepassword) {
          that.$message.error('密码不能为空哦')
          return
        }
        loading = this.$loading({
          lock: true,
          text: '提交中',
          spinner: 'el-icon-loading',
          background: '#0000000'
        })

        data = {
          Account: emailnumber,
          Password: phonepassword,
          Source: 'web',
          Type: '2'
        }
      }

      // console.log(data);

      phonelogin(data)
        .then((res) => {
          if (res.data.Code == 0) {
            localStorage.setItem('AccessToken', res.data.Data.AccessToken)
            localStorage.setItem('RefreshToken', res.data.Data.RefreshToken)
            localStorage.setItem(
              'AccessTokenTime',
              res.data.Data.AccessTokenTime
            )
            localStorage.setItem(
              'RefreshTokenTime',
              res.data.Data.RefreshTokenTime
            )
            // localStorage.setItem("phonenumber", phone);
            // localStorage.setItem("password", phonepassword);
            localStorage.setItem('username', res.data.Data.MemberName)

            that.$message({
              message: '登录成功',
              type: 'success',
              center: true,
              duration: 1000,
              customClass: 'sps'
            })
            loading.close()
            var returnurl = localStorage.getItem('cacheUrl')
            if (returnurl && returnurl != '') {
              window.location.href = returnurl
            } else {
              setTimeout(() => {
                that.$router.push(that.goPage)
              }, 1000)
            }
          } else {
            loading.close()
            that.fetch_static = false
            that.$message({
              message: res.data.Message,
              type: 'warning',
              center: true,
              customClass: 'sps'
            })
          }
        })
        .catch((error) => {
          loading.close()
          that.fetch_static = false
          console.log('失败' + error)
        })
    },
    fu(){
      this.$router.push({path:'/page/service'})
    }
  }
}
</script>
